module.exports = __webpack_public_path__ + "static/media/question_plain.e9430b82.png";